function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Heart Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13,0.5 C15.4937412,0.5 17.5,2.66077294 17.5,5.308 C17.5,5.60757078 17.4709245,5.91110009 17.4139158,6.21812346 C17.0480546,8.1884878 15.5697651,10.2326326 13.3381791,12.2817865 C12.4475607,13.0995968 11.4951947,13.8623944 10.5428858,14.5506756 C10.2094995,14.7916306 9.89967104,15.0062404 9.62116523,15.1919739 C9.45288038,15.3042019 9.33156515,15.3823956 9.26499947,15.4239992 C9.11729243,15.516316 8.93218737,15.5251107 8.7763932,15.4472136 C8.70811316,15.4130736 8.58506346,15.3486304 8.41501447,15.2549638 C8.1344189,15.1004057 7.82248436,14.9188298 7.48696544,14.7112834 C6.52896947,14.1186831 5.5710044,13.4352229 4.67490945,12.6683896 C2.0748669,10.4434032 0.5,7.97519307 0.5,5.308 C0.5,2.66077294 2.5062588,0.5 5,0.5 C6.89456626,0.5 8.29904979,1.30285575 9,2.37727987 C9.70095021,1.30285575 11.1054337,0.5 13,0.5 Z M9.06633477,14.3600105 C9.33470396,14.181037 9.63425054,13.9735491 9.95711418,13.7401994 C10.8798053,13.0733244 11.8024393,12.3343407 12.6618209,11.5452135 C14.7473954,9.63013483 16.1142138,7.74012963 16.4307214,6.03556196 C16.4767669,5.7875814 16.5,5.54504274 16.5,5.308 C16.5,3.19716282 14.9241992,1.5 13,1.5 C10.7761424,1.5 9.5,2.77614237 9.5,4 C9.5,4.66666667 8.5,4.66666667 8.5,4 C8.5,2.77614237 7.22385763,1.5 5,1.5 C3.07580085,1.5 1.5,3.19716282 1.5,5.308 C1.5,7.62130693 2.9251331,9.85484678 5.32509055,11.9086104 C6.1789956,12.6393396 7.09603053,13.2935982 8.01303456,13.8608416 C8.33376564,14.0592405 8.6312061,14.2323794 8.89748553,14.3790519 C8.9244587,14.3939093 8.95007068,14.407929 8.97428245,14.4211053 C9.00296891,14.4021633 9.03367532,14.3817908 9.06633477,14.3600105 Z",
  id: "heart-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "heart-Icon/Global/heart",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "heart-Swatches/DarkGreen",
  transform: "translate(3.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "heart-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#heart-path-1"
})));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.2ed803e0.svg";
export { ForwardRef as ReactComponent };